import config from '@/config';
import {ApiBase, InternationalizedField, ListOptions} from '@/api/common';
import ApiList from '@/api/list';

const NO_UPLOAD_FIELDS = [
    'icon_link',
    'submodule_id',
];

export default class Submodule extends ApiBase<Submodule> {
    public static readonly SLUG: string = 'submodule';
    private static readonly URL_BASE: string = config.API_ROOT + '/submodule/';
    
    // Initializing these fields (even with undefined)
    // is necessary, so hasOwnAttribute can find them.
    public icon?: number|null = undefined;
    public icon_link?: string|null = undefined;
    public parent_module?: number = undefined;
    public submodule_id?: string = undefined;
    public order?: number = undefined;
    public name: InternationalizedField<string> = new InternationalizedField<string>();
    public description: InternationalizedField<string> = new InternationalizedField<string>();
    
    // currently unused
    public spreadsheet?: string = undefined;
    
    public constructor() {
        super({
            urlBase: Submodule.URL_BASE,
            filteredFields: NO_UPLOAD_FIELDS,
        });
    }
    
    public assign(response: any): Submodule {
        super.assign(response);
        
        if (response) {
            if ('name' in response) {
                this.name = new InternationalizedField<string>(response.name);
            }
            if ('description' in response) {
                this.description = new InternationalizedField<string>(response.description);
            }
        }
        
        return this;
    }
    
    public static async get(id: number): Promise<Submodule> {
        return this.doGet({
            urlBase: Submodule.URL_BASE,
            id,
            create: (response) => new Submodule().assign(response),
        });
    }
    
    public static async list(): Promise<ApiList<Submodule>> {
        const options: ListOptions<Submodule> = {
            urlBase: Submodule.URL_BASE,
            create: (response) => new Submodule().assign(response),
        };
        return this.doList(options);
    }
    
    public static async getSubmodulesOfModule(id: number): Promise<ApiList<Submodule>> {
        const options: ListOptions<Submodule> = {
            urlBase: Submodule.URL_BASE,
            create: (response) => new Submodule().assign(response),
            all: true,
            parameters: {
                parent_module: id,
                minimal: true,
            },
        };
        return this.doList(options);
    }
    
    public getName(): string {
        const name = this.name.getDefaultValue();
        if (name) {
            return name;
        }
        return '';
    }
}
